export default __webpack_public_path__ + "static/media/podcast-theme.ec0426d3.jpg";